import React from 'react'
import Buttons from './element/buttons';

var pathinfo = require('pathinfo');

export default function PartTextImage(props) {
    let part = props.part;
    let flex_type = '';
    let flex_align = '';
    switch (part['image_position']) {
        case 'top':
            flex_type = 'column';
            flex_align = ' items-center';
            break;
        case 'left':
            flex_type = 'row';
            flex_align = ' items-center';
            break;
        case 'right':
            flex_type = 'row-reverse';
            flex_align = ' items-start';
            break;
        case 'bottom':
            flex_type = 'column-reverse';
            flex_align = ' items-center';
            break;
        default:
            flex_type = 'row';
            flex_align = ' items-start';
            break;
    }
    
    let has_image = '';
    let image_path = '';
    if(part['media']['main_image']['path']){
        has_image = 'has_image';
        if(part['image_width'] !== 0  && part['image_height'] !== 0){
            // image_path = Image::resize(part['media']['main_image']['path'], part['image_width'], part['image_height']);
            image_path = part['media']['main_image']['path']; //width x height
        }else{
            image_path = part['media']['main_image']['path'];
        }
    }
    let template_featured = part['text_featured'] ? 'part-featured' : '';

    if (part['media']['main_image']) {
        var image_style = {};
        var image_ratio = '';
        var image_size = 'cover';
        if(part['image_adjust']){
            image_size = 'contain';
        }

        if (part['image_width'] === 0 && part['image_height'] === 0) {
            image_size = 'static';
        } else {
            if (part['image_height'] === 0) {
                image_size = "static";
            }
            var image_width = part['image_width'] === 0? "100%": `${part['image_width']}px`;
            var image_height = part['image_height'] === 0? "auto": `${part['image_height']}px`;
            image_style = { width: image_width, minWidth: image_width, height: image_height };
        }
        // let image_info = pathinfo(part['media']['main_image']['path']);

        var hide_reponsive = '';
        // if (image_info['filename'] === 'pixel') {
        //     hide_reponsive = 'hide-responsive';
        // }
    }


    return (
        <div className={`flex ${flex_type} ${flex_align} ${has_image} ${template_featured}`}>
            {
                part['media']['main_image'] &&
                    <div className={`image ${image_size} ${hide_reponsive}`} style={image_style}>
                        <img className={image_ratio} src={image_path} alt={part['media']['main_image']['alt']} title={part['media']['main_image']['title']} />
                    </div>
            } 
            <div className="text-block">
                <div className="text">
                    <div dangerouslySetInnerHTML={{__html: part['content']}} />
                    {
                        props.part_buttons &&
                            <Buttons part_buttons={props.part_buttons} />
                    }
                </div>
            </div>
        </div>

    )
}

